import { Outlet } from "react-router";
import { AuthProvider } from "../contexts/AuthContext";
import { CouponsProvider } from "../contexts/CouponsContext";
import { CookieConsentProvider, useCookieConsent } from "../contexts/CookieConsentContext";
import { ScrollToTop } from "./ScrollToTop";
import { CookieConsentManager } from "./CookieConsentManager";
import { GoogleAnalyticsManager } from "./GoogleAnalyticsManager";

function CookieConsentRuntime() {
  const { consent, hasAnalyticsConfigured } = useCookieConsent();

  return (
    <>
      <GoogleAnalyticsManager
        consent={consent}
        hasAnalyticsConfigured={hasAnalyticsConfigured}
      />
      <CookieConsentManager />
    </>
  );
}

export function RootProvider() {
  return (
    <AuthProvider>
      <CookieConsentProvider>
        <CouponsProvider>
          <ScrollToTop />
          <Outlet />
          <CookieConsentRuntime />
        </CouponsProvider>
      </CookieConsentProvider>
    </AuthProvider>
  );
}
